export function detectIfBannerCtaClicked() {
	const hash = window.location.hash.replace('#', '');
	const params = new URLSearchParams(hash);
	return params.get('emit') === 'command.overlay.close';
}
